import { Pipe, PipeTransform } from '@angular/core';
import { SpecLineModel } from 'web-shared';

@Pipe({
  name: 'isSpecValueInvalid'
})
export class IsSpecValueInvalidPipe implements PipeTransform {

  transform(spec: SpecLineModel): boolean {
    return spec.isValueInvalid();
  }
}
